import React from 'react';
import { Container, Row, Col, Button, Card } from 'react-bootstrap';
import { FaVideo, FaClock, FaUserMd, FaLaptopMedical } from 'react-icons/fa';
import './Teleconsultation.css';

const Teleconsultation = () => {
  return (
    <div className="teleconsultation-page">
      <section className="page-hero">
        <Container>
          <h1>Teleconsultation Services</h1>
          <p>Expert Medical Advice from the Comfort of Your Home</p>
        </Container>
      </section>

      <section className="tele-intro">
        <Container>
          <Row className="align-items-center">
            <Col lg={6} className="mb-4 mb-lg-0">
              <h2>What is Teleconsultation?</h2>
              <p>
                Teleconsultation allows you to consult with our experienced doctors remotely through 
                video calls, ensuring you receive quality medical advice without leaving your home.
              </p>
              <p>
                Perfect for follow-up consultations, prescription renewals, general health queries, 
                and non-emergency medical advice.
              </p>
              <a
                href="https://wa.me/919361207761?text=Hi%2C%20I%20am%20interested%20in%20booking%20a%20teleconsultation.%20Can%20you%20please%20share%20the%20next%20steps%20and%20available%20slots%3F"
                className="btn btn-primary btn-lg"
                target="_blank"
                rel="noopener noreferrer"
              >
                Book Consultation
              </a>
            </Col>
            <Col lg={6}>
              <img 
                src="https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=800" 
                alt="Teleconsultation" 
                className="img-fluid rounded shadow"
              />
            </Col>
          </Row>
        </Container>
      </section>

      <section className="tele-benefits">
        <Container>
          <h2 className="text-center mb-5">Benefits of Teleconsultation</h2>
          <Row className="g-4">
            <Col lg={3} md={6}>
              <Card className="benefit-card h-100 text-center">
                <Card.Body>
                  <FaVideo className="benefit-icon" />
                  <h4>Convenient</h4>
                  <p>Consult from anywhere at any time</p>
                </Card.Body>
              </Card>
            </Col>
            <Col lg={3} md={6}>
              <Card className="benefit-card h-100 text-center">
                <Card.Body>
                  <FaClock className="benefit-icon" />
                  <h4>Time-Saving</h4>
                  <p>No travel or waiting time required</p>
                </Card.Body>
              </Card>
            </Col>
            <Col lg={3} md={6}>
              <Card className="benefit-card h-100 text-center">
                <Card.Body>
                  <FaUserMd className="benefit-icon" />
                  <h4>Expert Doctors</h4>
                  <p>Access to qualified specialists</p>
                </Card.Body>
              </Card>
            </Col>
            <Col lg={3} md={6}>
              <Card className="benefit-card h-100 text-center">
                <Card.Body>
                  <FaLaptopMedical className="benefit-icon" />
                  <h4>Digital Records</h4>
                  <p>Easy access to medical history</p>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="how-it-works">
        <Container>
          <h2 className="text-center mb-5">How It Works</h2>
          <Row className="g-4">
            <Col md={3}>
              <div className="step-card">
                <div className="step-number">1</div>
                <h4>Book Appointment</h4>
                <p>Call us or book online</p>
              </div>
            </Col>
            <Col md={3}>
              <div className="step-card">
                <div className="step-number">2</div>
                <h4>Receive Link</h4>
                <p>Get video call link via SMS</p>
              </div>
            </Col>
            <Col md={3}>
              <div className="step-card">
                <div className="step-number">3</div>
                <h4>Consult Doctor</h4>
                <p>Connect with our specialist</p>
              </div>
            </Col>
            <Col md={3}>
              <div className="step-card">
                <div className="step-number">4</div>
                <h4>Get Prescription</h4>
                <p>Receive digital prescription</p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default Teleconsultation;
